export const OFFLINE_CAPABLE_PATHS: ReadonlySet<string> = new Set([
  '/',
  '/operations',
  '/stoppages',
  '/production/list',
  '/production/show',
  '/production/rehandle',
  '/production/crushing',
])
